import { createReducer, on } from '@ngrx/store';
import { ELoadStatus } from '../state.interface';
import { IDashboardContentState } from './dashboard-content-store.interface';
import { dashboardContentActions } from './dashboard-content.actions';

export const initialState: IDashboardContentState = {
  dashboardData: null,
  dashboardDataLoadStatus: ELoadStatus.initial,
  reassignWidgetsStatus: ELoadStatus.initial,
};

export const dashboardContentReducer = createReducer(
  initialState,
  on(
    dashboardContentActions.fetchDashboardContents,
    (state): IDashboardContentState => ({ ...state, dashboardDataLoadStatus: ELoadStatus.loading }),
  ),
  on(
    dashboardContentActions.fetchDashboardContentsCompleted,
    (state, action): IDashboardContentState => ({
      ...state,
      dashboardData: action.dashboardWithWidgets,
      dashboardDataLoadStatus: ELoadStatus.success,
    }),
  ),
  on(
    dashboardContentActions.reassignWidgets,
    (state): IDashboardContentState => ({ ...state, reassignWidgetsStatus: ELoadStatus.loading }),
  ),
  on(
    dashboardContentActions.reassignWidgetsCompleted,
    (state): IDashboardContentState => ({ ...state, reassignWidgetsStatus: ELoadStatus.success }),
  ),
  on(
    dashboardContentActions.resetReassignWidgetsStatus,
    (state): IDashboardContentState => ({ ...state, reassignWidgetsStatus: ELoadStatus.initial }),
  ),
  on(dashboardContentActions.updateNote, (state, { widgetId, note }): IDashboardContentState => {
    if (!state.dashboardData) {
      return state;
    }

    return {
      ...state,
      dashboardData: {
        ...state.dashboardData,
        widgets: state.dashboardData.widgets.map((widget) =>
          widget.id === widgetId
            ? { ...widget, typeBasedConfiguration: { ...widget.typeBasedConfiguration, note } }
            : widget,
        ),
      },
    };
  }),
);
